/* Nakamory TCG - Theme JS */
/* NOTE: Mobile nav toggle is handled in sections/nakamory-header.liquid */
(function () {
  'use strict';

  // Smooth scroll anchors
  document.querySelectorAll('a[href^="#"]').forEach(function(link) {
    link.addEventListener('click', function(e) {
      var id = link.getAttribute('href');
      if (id.length > 1) {
        var t = document.querySelector(id);
        if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth' }); }
      }
    });
  });

  // Variant picker
  document.querySelectorAll('[data-variant-form]').forEach(function(form) {
    form.querySelectorAll('input[type="radio"][name^="options"]').forEach(function(radio) {
      radio.addEventListener('change', function() { updateVariant(form); });
    });
  });

  function updateVariant(form) {
    var variantsData = JSON.parse(form.dataset.variants || '[]');
    var optionNames = JSON.parse(form.dataset.optionNames || '[]');
    var selected = optionNames.map(function(name) {
      var checked = form.querySelector('input[name="options[' + name + ']"]:checked');
      return checked ? checked.value : null;
    });
    var variant = variantsData.find(function(v) {
      return v.options.every(function(opt, i) { return opt === selected[i]; });
    });
    if (!variant) return;
    var idInput = form.querySelector('input[name="id"]');
    if (idInput) idInput.value = variant.id;
    var priceEl = form.querySelector('[data-price]');
    if (priceEl) priceEl.textContent = variant.price;
    var compareEl = form.querySelector('[data-compare-price]');
    if (compareEl) {
      compareEl.textContent = variant.compare_at_price || '';
      compareEl.style.display = variant.compare_at_price ? '' : 'none';
    }
    var submitBtn = form.querySelector('button[type="submit"]');
    if (submitBtn) {
      submitBtn.disabled = !variant.available;
      submitBtn.textContent = variant.available
        ? (submitBtn.dataset.labelAdd || 'In winkelwagen')
        : (submitBtn.dataset.labelSoldOut || 'Uitverkocht');
    }
  }

  // Qty steppers
  document.querySelectorAll('.qty-wrapper').forEach(function(wrap) {
    var input = wrap.querySelector('input[type="number"]');
    if (!input) return;
    wrap.querySelectorAll('button[data-qty]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        var step = parseInt(btn.dataset.qty, 10);
        var min = parseInt(input.min || 1, 10);
        var cur = parseInt(input.value || min, 10);
        input.value = Math.max(min, cur + step);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  // Filter chips
  var filterChips = document.querySelectorAll('.filter-chip[data-group]');
  if (filterChips.length) {
    var active = { game: 'all', type: 'all' };
    filterChips.forEach(function(chip) {
      chip.addEventListener('click', function() {
        var g = chip.dataset.group, v = chip.dataset.value;
        document.querySelectorAll('.filter-chip[data-group="' + g + '"]')
          .forEach(function(c) { c.classList.remove('active'); });
        chip.classList.add('active');
        active[g] = v;
        document.querySelectorAll('.product-card[data-game]').forEach(function(card) {
          var gMatch = active.game === 'all' || card.dataset.game === active.game;
          var tMatch = active.type === 'all' || card.dataset.type === active.type;
          card.style.display = gMatch && tMatch ? '' : 'none';
        });
      });
    });
  }
})();
